import { DocumentKeyEnum } from './enums/DocumentKeyEnum';
let gMain;
const init = (main) => {
    gMain = main;
};
const msgBoxOk = (message, options) => {
    if (!gMain) {
        return;
    }
    const main = gMain;
    main.$bvModal.msgBoxOk(message, options);
};
const modalHelper = {
    init,
    msgBoxOk,
};
const doc = document;
if (!doc[DocumentKeyEnum.Modal]) {
    doc[DocumentKeyEnum.Modal] = modalHelper;
}
export { modalHelper, };
